var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: _vm.selectedPlant === null,
                },
                on: {
                  click: function ($event) {
                    return _vm.showCreateForm()
                  },
                },
              },
              [_vm._v(" Create New Employee ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _vm.user.group.plants && _vm.user.group.plants.length != 0
                    ? _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: { icon: "industry", expanded: "" },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            },
                            _vm._l(_vm.user.group.plants, function (plant) {
                              return _c(
                                "option",
                                { key: plant.id, domProps: { value: plant } },
                                [_vm._v(" " + _vm._s(plant.name) + " ")]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c(
                        "b-field",
                        { attrs: { label: "Plant" } },
                        [
                          _c("multiselect", {
                            staticStyle: { "min-width": "400px" },
                            attrs: {
                              options: _vm.plants,
                              multiple: false,
                              "close-on-select": true,
                              placeholder: "Pick plant",
                              "custom-label": (obj) =>
                                obj.id + " - " + obj.name,
                              "track-by": "name",
                            },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "left-right",
                      attrs: {
                        type: "is-warning",
                        "icon-left": "arrows-rotate",
                        disabled: _vm.isLoading || _vm.selectedPlant === null,
                      },
                      on: {
                        click: () => {
                          _vm.resetData()
                          _vm.getData()
                        },
                      },
                    },
                    [_vm._v(" Load ")]
                  ),
                ],
                1
              ),
              _vm.employees.length != 0
                ? _c("ag-grid-vue", {
                    staticClass: "ag-theme-balham",
                    staticStyle: { width: "100%", height: "700px" },
                    attrs: {
                      "row-data": _vm.employees,
                      "grid-options": _vm.gridOptions,
                      pagination: true,
                      "pagination-auto-page-size": true,
                      "cache-overflow-size": 0,
                      "multi-sort-key": "ctrl",
                      modules: _vm.modules,
                      "get-context-menu-items": _vm.getContextMenuItems,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isCreatingEmployee,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingEmployee = $event
            },
          },
        },
        [
          _vm.isCreatingEmployee
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEmployee.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Create Employee "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "First Name" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "First Name",
                                    },
                                    model: {
                                      value: _vm.newEmployee.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.newEmployee, "name", $$v)
                                      },
                                      expression: "newEmployee.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Last Name" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "Last Name",
                                    },
                                    model: {
                                      value: _vm.newEmployee.surname,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEmployee,
                                          "surname",
                                          $$v
                                        )
                                      },
                                      expression: "newEmployee.surname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Arrival Date" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "date" },
                                    model: {
                                      value: _vm.newEmployee.date_entree,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEmployee,
                                          "date_entree",
                                          $$v
                                        )
                                      },
                                      expression: "newEmployee.date_entree",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Exit Date" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "date" },
                                    model: {
                                      value: _vm.newEmployee.date_sortie,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEmployee,
                                          "date_sortie",
                                          $$v
                                        )
                                      },
                                      expression: "newEmployee.date_sortie",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Employee Id" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "text", placeholder: "Id" },
                                    model: {
                                      value: _vm.newEmployee.matricule,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.newEmployee,
                                          "matricule",
                                          $$v
                                        )
                                      },
                                      expression: "newEmployee.matricule",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "left-right",
                                  staticStyle: { "margin-top": "auto" },
                                  attrs: { type: "is-warning" },
                                  on: {
                                    click: () => {
                                      _vm.generateUserId()
                                    },
                                  },
                                },
                                [_vm._v(" Generate uuid ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Employee Title" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.newEmployee.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newEmployee, "title", $$v)
                                  },
                                  expression: "newEmployee.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Interim?" } },
                            [
                              _c(
                                "b-switch",
                                {
                                  model: {
                                    value: _vm.newEmployee.interim,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newEmployee, "interim", $$v)
                                    },
                                    expression: "newEmployee.interim",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.newEmployee.interim ? "Yes" : "No"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            active: _vm.isEditingEmployee,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingEmployee = $event
            },
          },
        },
        [
          _vm.isEditingEmployee
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Employee "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "First Name" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "Name",
                                    },
                                    model: {
                                      value: _vm.editableEmployee.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableEmployee,
                                          "name",
                                          $$v
                                        )
                                      },
                                      expression: "editableEmployee.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Last Name" } },
                                [
                                  _c("b-input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "Surname",
                                    },
                                    model: {
                                      value: _vm.editableEmployee.surname,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableEmployee,
                                          "surname",
                                          $$v
                                        )
                                      },
                                      expression: "editableEmployee.surname",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Arrival Date" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "date" },
                                    model: {
                                      value: _vm.editableEmployee.date_entree,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableEmployee,
                                          "date_entree",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editableEmployee.date_entree",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-field",
                                { attrs: { label: "Exit Date" } },
                                [
                                  _c("b-input", {
                                    attrs: { type: "date" },
                                    model: {
                                      value: _vm.editableEmployee.date_sortie,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editableEmployee,
                                          "date_sortie",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editableEmployee.date_sortie",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Employee Title" } },
                            [
                              _c("b-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.editableEmployee.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.editableEmployee, "title", $$v)
                                  },
                                  expression: "editableEmployee.title",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-field",
                            { attrs: { label: "Interim?" } },
                            [
                              _c(
                                "b-switch",
                                {
                                  model: {
                                    value: _vm.editableEmployee.interim,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.editableEmployee,
                                        "interim",
                                        $$v
                                      )
                                    },
                                    expression: "editableEmployee.interim",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.editableEmployee.interim
                                          ? "Yes"
                                          : "No"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }